import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./common";
import { Location } from "../../schema/types/location/entity";

export const locationApi = createApi({
  reducerPath: "locationApi",
  baseQuery: customBaseQuery,
  tagTypes: ["Location"],
  endpoints: (builder) => ({
    getLocation: builder.query<Location, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: link });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => [{ type: "Location", id: link }],
    }),
  }),
});

export const { useGetLocationQuery } = locationApi;
